import { Component, ViewChild, Injector, HostListener, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { AppComponentBase } from '../../../../shared/common/app-component-base';
import { ClientsServiceProxy, RcopiaServiceProxy } from '../../../../shared/service-proxies/service-proxies';

declare function gmtTime(): any;
declare function calcMD5(str): string;

@Component({
    selector: 'rcopiaPopUpModal',
    templateUrl: './rcopia-popup.component.html',
    styleUrls: ['./rcopia-popup.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        CommonModule,
        ModalDirective
    ]
})
export class RcopiaPopupComponent extends AppComponentBase implements OnInit {
    @ViewChild('RcopiaPopUp') RcopiaPopUp: ModalDirective;
    
    type = "";
    timeStamp: any;
    screenHeight: number;
    screenWidth: number;
    modalheight = 0;
    showFrame = false;
    saving = false;
    isLoading = false;
    iframeKey = 0;

    constructor(
        injector: Injector,
        private _clientsServiceProxy: ClientsServiceProxy,
        private _rcopiaServiceProxy: RcopiaServiceProxy,
        private sanitizer: DomSanitizer,
    ) {
        super(injector);
        this.onResize();
    }

    @HostListener('window:resize', ['$event'])
    onResize(event?: Event): void {
        this.screenHeight = window.innerHeight;
        this.modalheight = this.screenHeight - 55;
        this.screenWidth = window.innerWidth - 50;
    }

    ngOnInit(): void {
    }

    show(type: string): void {
        this.type = type;
        //this.loadRcopiaPopup();
    }

    showForNotification(notificationScreen: string): void {
        this.type = notificationScreen;
        this.loadRcopiaNotification(notificationScreen);
    }

    RcopiaClose(): void {
        document.body.classList.remove('rcopia-modal-open');
        this.updateMedication();
        this.RcopiaPopUp.hide();
        // Notify any open page (med management, client profile, psych eval) to refresh
        abp.event.trigger('app.rcopia.popupClosed');
    }

    // async loadRcopiaPopup() {
    //     this.isLoading = true;
    //     this.showFrame = false;
        
    //     try {
    //         const result = await this._rcopiaServiceProxy.getRcopiaLaunchUrl(
    //             clientId
    //             locationId
    //         ).toPromise();
            
    //         this.RcopiaPopUp.show();
    //         this.submitExtInvokeForm(result.landingUrl, result.bearerToken);
            
    //     } catch (error) {
    //         console.error('ERROR loading Rcopia popup:', error);
    //         this.message.error('Failed to load Rcopia. Please try again.');
    //         this.isLoading = false;
    //     }
    // }

    async loadRcopiaNotification(notificationScreen: string) {
        this.isLoading = true;
        this.showFrame = false
        
        try {
            const result = await this._rcopiaServiceProxy.getRcopiaNotificationLaunchUrl(
                notificationScreen
            ).toPromise();
            
            document.body.classList.add('rcopia-modal-open');
            this.RcopiaPopUp.show();
            this.submitExtInvokeForm(result.landingUrl, result.bearerToken);

        } catch (error) {
            console.error('ERROR loading Rcopia notification:', error);
            this.message.error('Failed to load Rcopia. Please try again.');
            this.isLoading = false;
            document.body.classList.remove('rcopia-modal-open');
        }
    }

    private submitExtInvokeForm(landingUrl: string, bearerToken: string): void {
        this.isLoading = false;
        this.showFrame = true;
        this.iframeKey++;
        
        setTimeout(() => {
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = landingUrl;
            form.target = 'rcopia-popup-iframe-' + this.iframeKey;
            form.style.display = 'none';
            
            const tokenInput = document.createElement('input');
            tokenInput.type = 'hidden';
            tokenInput.name = 'token';
            tokenInput.value = bearerToken;
            form.appendChild(tokenInput);
            
            document.body.appendChild(form);
            
            const created = this.createIframe('rcopia-popup-iframe-' + this.iframeKey);
            
            if (created) {
                form.submit();
            } else {
                this.message.error('Failed to load Rcopia.');
            }
            
            setTimeout(() => {
                if (document.body.contains(form)) {
                    document.body.removeChild(form);
                }
            }, 500);
        }, 150);
    }

    private createIframe(iframeName: string): boolean {
        try {
            const modalElement = document.querySelector('rcopiaPopUpModal');
            if (!modalElement) {
                return false;
            }
            
            const modalBody = modalElement.querySelector('.modal-body');
            if (!modalBody) {
                return false;
            }
            
            const oldIframe = modalBody.querySelector('iframe');
            if (oldIframe) {
                oldIframe.remove();
            }
            
            const iframe = document.createElement('iframe');
            iframe.name = iframeName;
            iframe.className = 'w-100 h-100 border-0';
            iframe.style.border = '0';
            iframe.style.width = '100%';
            iframe.style.height = '100%';
            
            modalBody.appendChild(iframe);
            
            return true;
            
        } catch (error) {
            console.error('Error creating iframe:', error);
            return false;
        }
    }

    updateMedication(): void {
        this.saving = true;
        this.timeStamp = Date.now();
        
        this._clientsServiceProxy.updateMedicationFromRcopia(this.timeStamp.toString()).subscribe(
            result => {
                setTimeout(() => {
                    this.saving = false;
                }, 5000);
            },
            error => {
                this.saving = false;
            }
        );
    }
}